import type { ReactNode } from 'react';
import styles from './Badge.module.css';

type Tone = 'brand' | 'success' | 'warning' | 'danger' | 'neutral';

interface BadgeProps {
  tone?: Tone;
  dot?: boolean;
  pulse?: boolean;
  children: ReactNode;
}

export function Badge({ tone = 'neutral', dot = false, pulse = false, children }: BadgeProps) {
  const classes = [styles.badge, styles[tone], pulse ? styles.pulse : ''].filter(Boolean).join(' ');

  return (
    <span className={classes}>
      {dot && <span className={styles.dot} />}
      {children}
    </span>
  );
}
